import React from "react"

const PageSectionTitle = ({ children }) => {
  return <h2 style={{ fontWeight: "bold", fontSize: "1rem" }}>{children}</h2>
}

export default PageSectionTitle
